import { useState } from 'react';

import { Grid2 as Grid, ClickAwayListener } from '@mui/material';

import { FEEDBACK } from 'src/utils/constants';

import BadFeedback from './BadFeedback';
import OtherFeedback from './OtherFeedback';
import { useFeedbackContext } from '../hooks/useFeedbackContext';

function BadFeedbackCard() {
  const { onClose } = useFeedbackContext();
  const [isOther, setIsOther] = useState(false);

  const handleFeedbackChange = (value?: string) => {
    if (value === 'Other') {
      setIsOther(true);
    } else {
      onClose(value);
    }
  };

  return (
    <ClickAwayListener onClickAway={() => onClose()}>
      <Grid gap={2} container display="flex" direction="column">
        {!isOther ? (
          <BadFeedback data={FEEDBACK.BAD_FEEDBACKS} onChange={handleFeedbackChange} />
        ) : (
          <OtherFeedback />
        )}
      </Grid>
    </ClickAwayListener>
  );
}

export default BadFeedbackCard;
